var _path, _circle, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashBinMetalPinRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 48,
    viewBox: "0 0 33 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6434 16.3217C32.6434 25.3359 16.3217 47.4813 16.3217 47.4813C16.3217 47.4813 0 25.3359 0 16.3217C0 7.30747 7.30747 0 16.3217 0C25.3359 0 32.6434 7.30747 32.6434 16.3217Z",
    fill: "#D00404"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 11,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1601 12.1808L13.6276 11.4573C13.8118 11.1722 14.1281 11 14.4675 11H17.5325C17.8719 11 18.1882 11.1722 18.3724 11.4573L18.8399 12.1808C18.9444 12.3425 19 12.531 19 12.7235V19.6425C19 19.9023 18.8989 20.1519 18.7181 20.3385L18.3716 20.696C18.1832 20.8903 17.9242 21 17.6535 21H14.3465C14.0758 21 13.8168 20.8903 13.6284 20.696L13.2819 20.3385C13.1011 20.1519 13 19.9023 13 19.6425V12.7235C13 12.531 13.0556 12.3425 13.1601 12.1808Z",
    stroke: "#4F4F4F",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 13L19 13",
    stroke: "#4F4F4F",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 19L19 19",
    stroke: "#4F4F4F",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashBinMetalPinRed);
export default __webpack_public_path__ + "static/media/trash-bin-metal-pin-red.b1598a38d7f6a275b4c006149490eabb.svg";
export { ForwardRef as ReactComponent };